/**
 * @fileoverview Tradução e datas da abordagem inteligente na conversa (faixa,
 * "Detalhes" e modal de templates).
 */

import { translateWithLiterals } from "../../utils/translateWithLiterals";
import { locale } from "../Triage/helpers";

/** Textos de `smartApproaches.*`, com os valores (nomes, tempos) por fora da interpolação do i18next. */
export const tr = (key, params) => translateWithLiterals(`smartApproaches.${key}`, params || {});

/** Dia e hora curtos no idioma da tela ("21/10", "08:00"). */
export const formatAt = (date) => ({
  date: date.toLocaleDateString(locale(), { day: "2-digit", month: "2-digit" }),
  time: date.toLocaleTimeString(locale(), { hour: "2-digit", minute: "2-digit" }),
});
